<template>
  <span class="gmf-loading-spinner" :style="{ borderTopColor: color }"></span>
</template>
<style>
.gmf-loading-spinner {
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  border-top: 2px solid var(--gmf-col-nearblack);
  animation: gmf-spinner 0.5s linear infinite; 
}
@keyframes gmf-spinner {
  to { transform: rotate(360deg); }
}
</style>
<script>
export default {
  data () {
    return {};
  },
  props: {
    color: {
      type: String,
      default: 'var(--gmf-col-nearblack)'
    }
  }
};
</script>